import { PinMarker } from "@local-logic/elements-react";
import React from "react";
import { Marker } from "react-map-gl";

interface PinProps {
  marker: {
    icon?: "house" | "pin";
    lat: number;
    lng: number;
  };
}

const Pin = React.memo(({ marker }: PinProps) => (
  <Marker latitude={marker.lat} longitude={marker.lng} style={{ zIndex: 1 }}>
    <PinMarker.Root
      options={{
        style: marker.icon || "house",
      }}
    />
  </Marker>
));

Pin.displayName = "Pin";

export default Pin;
